import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './WhatsAppStatusPanel.css';

const WhatsAppStatusPanel = ({ slug, stats }) => {
  console.log('🔍 WhatsAppStatusPanel stats:', stats);
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showQR, setShowQR] = useState(false);
  const [qrCode, setQrCode] = useState(null);
  const [qrTimestamp, setQrTimestamp] = useState(null);
  const [qrCreating, setQrCreating] = useState(false);
  const [qrValidityCountdown, setQrValidityCountdown] = useState(null);
  const [countdown, setCountdown] = useState(null);
  const [autoCheckInterval, setAutoCheckInterval] = useState(null);
  const [qrCheckInterval, setQrCheckInterval] = useState(null); // QR hazır olana kadar kontrol interval'i
  const [isCompact, setIsCompact] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsCompact(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const fetchStatus = async () => {
    try {
      setLoading(true);
      // Tek endpoint kullan: /api/status/:slug
      const response = await fetch(`/api/status/${slug}`);
      const data = await response.json();
      
      if (data.success) {
        const statusData = data.data;
        console.log('🔍 StatusData:', statusData);
        console.log('🔍 StatusData.status:', statusData.status);
        console.log('🔍 StatusData.connected:', statusData.connected);
        
        // Durum belirleme: connected, qr_waiting, veya not_started
        let panelAction = 'not_started';
        let panelButtonText = 'Oturumu Başlat';
        let panelMessage = 'WhatsApp entegrasyonu için önce oturumu başlatmanız gerekiyor';
        
        if (statusData.status === 'connected' || statusData.connected === true) {
          panelAction = 'connected';
          panelButtonText = 'Bağlandı';
          panelMessage = 'WhatsApp bağlantısı aktif!';
        } else if (statusData.status === 'qr_waiting') {
          // Sadece qr_waiting → bağlantı seçeneklerini göster
          panelAction = 'show_qr';
          panelButtonText = 'QR Kodunuzu Oluşturun';
          panelMessage = 'WhatsApp entegrasyonu için QR kod oluşturmanız gerekiyor';
        } else if (statusData.status === 'initializing') {
          // Tarayıcı hala açılıyor → yükleme ekranı göster
          panelAction = 'initializing';
          panelButtonText = 'Başlatılıyor...';
          panelMessage = 'WhatsApp tarayıcısı açılıyor, lütfen bekleyin...';
        } else if (statusData.status === 'disconnected' || statusData.status === 'not_initialized') {
          panelAction = 'not_started';
          panelButtonText = 'Oturumu Başlat';
          panelMessage = 'WhatsApp entegrasyonu için önce oturumu başlatmanız gerekiyor';
        }
        
        setStatus({
          status: statusData.status,
          live_status: statusData.status,
          whatsapp_status: statusData.status,
          panel_action: panelAction,
          panel_button_text: panelButtonText,
          panel_message: panelMessage,
          last_check: new Date().toISOString(),
          proxy_status: statusData.proxy_status || 'Bilinmiyor',
          last_session_start: statusData.last_session_start,
          connected_phone: statusData.connected_phone || 'Bilinmiyor'
        });
        setError(null);
      } else {
        setError('Durum alınamadı');
      }
    } catch (err) {
      setError('Durum alınamadı');
    } finally {
      setLoading(false);
    }
  };

  const refreshStatus = async () => {
    try {
      setLoading(true);
      // Aynı endpoint'i kullan: /api/status/:slug
      const response = await fetch(`/api/status/${slug}`);
      const data = await response.json();
      
      if (data.success) {
        const statusData = data.data;
        console.log('🔍 RefreshStatusData:', statusData);
        
        // Durum belirleme: connected, qr_waiting, veya not_started
        let panelAction = 'not_started';
        let panelButtonText = 'Oturumu Başlat';
        let panelMessage = 'WhatsApp entegrasyonu için önce oturumu başlatmanız gerekiyor';
        
        if (statusData.status === 'connected' || statusData.connected === true) {
          panelAction = 'connected';
          panelButtonText = 'Bağlandı';
          panelMessage = 'WhatsApp bağlantısı aktif!';
        } else if (statusData.status === 'qr_waiting') {
          panelAction = 'show_qr';
          panelButtonText = 'QR Kodunuzu Oluşturun';
          panelMessage = 'WhatsApp entegrasyonu için QR kod oluşturmanız gerekiyor';
        } else if (statusData.status === 'initializing') {
          panelAction = 'initializing';
          panelButtonText = 'Başlatılıyor...';
          panelMessage = 'WhatsApp tarayıcısı açılıyor, lütfen bekleyin...';
        } else if (statusData.status === 'disconnected' || statusData.status === 'not_initialized') {
          panelAction = 'not_started';
          panelButtonText = 'Oturumu Başlat';
          panelMessage = 'WhatsApp entegrasyonu için önce oturumu başlatmanız gerekiyor';
        }
        
        setStatus({
          status: statusData.status,
          live_status: statusData.status,
          whatsapp_status: statusData.status,
          panel_action: panelAction,
          panel_button_text: panelButtonText,
          panel_message: panelMessage,
          last_check: new Date().toISOString(),
          proxy_status: statusData.proxy_status || 'Bilinmiyor',
          last_session_start: statusData.last_session_start,
          connected_phone: statusData.connected_phone || 'Bilinmiyor'
        });
        setError(null);
      } else {
        setError('Durum yenilenemedi');
      }
    } catch (err) {
      setError('Durum yenilenemedi');
    } finally {
      setLoading(false);
    }
  };

  const startSession = async () => {
    try {
      setLoading(true);
      setError(null);
      
      // Eğer zaten bir QR kontrol interval'i varsa temizle
      if (qrCheckInterval) {
        clearInterval(qrCheckInterval);
        setQrCheckInterval(null);
      }
      
      // API çağrısından ÖNCE initializing ekranını göster — kullanıcı anında feedback görsün
      setStatus(prev => ({
        ...(prev || {}),
        status: 'initializing',
        live_status: 'initializing',
        panel_action: 'initializing',
        panel_button_text: 'Başlatılıyor...',
        panel_message: 'WhatsApp tarayıcısı açılıyor...',
        last_check: new Date().toISOString(),
      }));
      
      console.log(`🚀 ${slug} Oturum başlatılıyor...`);
      
      // WhatsApp service init endpoint'ini kullan
      const response = await fetch(`https://panel.fbajans.com/api/whatsapp-service/init/${slug}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      
      const data = await response.json();
      
      if (data.success) {
        console.log(`✅ ${slug} Oturum başlatıldı, QR kodu hazır olana kadar kontrol ediliyor...`);
        setLoading(false);
        
        // QR hazır olana kadar 5 saniyede bir kontrol et
        const checkQRInterval = setInterval(async () => {
          try {
            console.log(`🔍 ${slug} QR kontrolü yapılıyor...`);
            
            // Status kontrolü
            const statusResponse = await fetch(`/api/status/${slug}`);
            const statusData = await statusResponse.json();
            
            if (statusData.success) {
              const currentStatus = statusData.data.status;
              
              // qr_waiting → kullanıcıya bağlantı yöntemini seçtir (otomatik QR yükleme yok)
              if (currentStatus === 'qr_waiting') {
                console.log(`✅ ${slug} WhatsApp hazır, bağlantı yöntemi seçim ekranı gösteriliyor`);
                clearInterval(checkQRInterval);
                setQrCheckInterval(null);
                setStatus(prev => ({
                  ...(prev || {}),
                  status: 'qr_waiting',
                  live_status: 'qr_waiting',
                  panel_action: 'show_qr',
                  panel_button_text: 'QR Kodunuzu Oluşturun',
                  panel_message: 'WhatsApp entegrasyonu için bağlantı yöntemini seçin',
                  last_check: new Date().toISOString(),
                }));
                setLoading(false);
              } else if (currentStatus === 'initializing') {
                // Hala açılıyor, beklemeye devam
                console.log(`⏳ ${slug} Hala başlatılıyor...`);
              } else if (currentStatus === 'connected' || currentStatus === 'authenticated') {
                // Zaten bağlandı, interval'i durdur
                console.log(`✅ ${slug} Zaten bağlandı, QR kontrolü durduruldu`);
                clearInterval(checkQRInterval);
                setQrCheckInterval(null);
                await fetchStatus();
                setLoading(false);
              }
            }
          } catch (err) {
            console.error(`❌ ${slug} QR kontrolü hatası:`, err);
          }
        }, 5000); // 5 saniyede bir kontrol
        
        setQrCheckInterval(checkQRInterval);
        
        // Maksimum 2 dakika bekle (24 kontrol)
        setTimeout(() => {
          console.log(`⏰ ${slug} QR kontrolü timeout (2 dakika), interval durduruluyor`);
          clearInterval(checkQRInterval);
          setQrCheckInterval(null);
          setLoading(false);
          
          // Hala QR gösterilmemişse kullanıcıya bilgi ver
          setError((prevError) => {
            // Sadece hata yoksa veya önceki hata timeout ile ilgili değilse
            if (!prevError || !prevError.includes('2 dakika')) {
              return 'QR kodu 2 dakika içinde hazır olmadı. Lütfen tekrar deneyin.';
            }
            return prevError;
          });
        }, 120000); // 2 dakika
        
        setError(null);
      } else {
        setError(data.message || data.error || 'Oturum başlatılamadı');
        setLoading(false);
      }
    } catch (err) {
      console.error(`❌ ${slug} Oturum başlatma hatası:`, err);
      setError('Oturum başlatılamadı: ' + err.message);
      setLoading(false);
      
      // Hata durumunda interval'i temizle
      if (qrCheckInterval) {
        clearInterval(qrCheckInterval);
        setQrCheckInterval(null);
      }
    }
  };

  const disconnectWhatsApp = async () => {
    try {
      setLoading(true);
      setError(null);
      
      console.log('🔌 WhatsApp bağlantısı kesiliyor...');
      
      // Backend proxy üzerinden disconnect (requireLocalhost bypass)
      const response = await fetch(`https://panel.fbajans.com/api/whatsapp/${slug}/disconnect`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      
      const data = await response.json();
      
      if (data.success) {
        // Status'u güncelle
        setStatus({
          status: 'disconnected',
          live_status: 'disconnected',
          whatsapp_status: 'disconnected',
          panel_action: 'show_qr',
          panel_button_text: 'QR Kodunuzu Oluşturun',
          panel_message: 'WhatsApp entegrasyonu için QR kod oluşturmanız gerekiyor',
          last_check: new Date().toISOString(),
          proxy_status: status?.proxy_status || 'Bilinmiyor',
          last_session_start: status?.last_session_start
        });
        
        // QR'ı gizle
        setShowQR(false);
        setQrCode(null);
        setQrValidityCountdown(null);
        
        // Otomatik kontrolü durdur
        if (autoCheckInterval) {
          clearInterval(autoCheckInterval);
          setAutoCheckInterval(null);
        }
        
        // QR kontrol interval'ini de durdur
        if (qrCheckInterval) {
          clearInterval(qrCheckInterval);
          setQrCheckInterval(null);
        }
        
        console.log('✅ WhatsApp bağlantısı kesildi!');
      } else {
        setError('Bağlantı kesilemedi');
      }
    } catch (err) {
      setError('Bağlantı kesilemedi: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

    // Otomatik bağlantı kontrolü
  useEffect(() => {
    if (showQR && qrCode) {
      // QR kod gösterildiğinde 2-3 saniyede bir bağlantı kontrolü başlat
      const interval = setInterval(async () => {
        try {
          const response = await fetch(`/api/whatsapp-service/status/${slug}`);
          const data = await response.json();
          
          if (data.success && data.data.status === 'connected') {
            // Bağlandı! QR'ı gizle ve interval'i durdur
            setShowQR(false);
            setQrCode(null);
            setQrValidityCountdown(null);
            clearInterval(interval);
            setAutoCheckInterval(null);
            
            // Status'u güncelle
            setStatus({
              status: 'connected',
              live_status: 'connected',
              whatsapp_status: 'connected',
              panel_action: 'connected',
              panel_button_text: 'Bağlandı',
              panel_message: 'WhatsApp bağlantısı aktif!',
              last_check: new Date().toISOString()
            });
            
            console.log('✅ WhatsApp bağlandı! Otomatik kontrol durduruldu.');
          }
        } catch (err) {
          console.log('Bağlantı kontrolü hatası:', err);
        }
      }, 10000); // 10 saniyede bir kontrol (daha az sıklıkta)
      
      setAutoCheckInterval(interval);
      
      // Cleanup function
      return () => {
        clearInterval(interval);
        setAutoCheckInterval(null);
      };
    }
  }, [showQR, qrCode, slug]);

  // QR geçerlilik süresi countdown
  useEffect(() => {
    if (qrValidityCountdown && qrValidityCountdown > 0) {
      const timer = setTimeout(() => {
        setQrValidityCountdown(qrValidityCountdown - 1);
      }, 1000);
      
      return () => clearTimeout(timer);
    } else if (qrValidityCountdown === 0) {
      // QR süresi doldu, gizle
      setShowQR(false);
      setQrCode(null);
      setQrValidityCountdown(null);
      if (autoCheckInterval) {
        clearInterval(autoCheckInterval);
        setAutoCheckInterval(null);
      }
    }
  }, [qrValidityCountdown, autoCheckInterval]);

  // İlk yükleme
  useEffect(() => {
    fetchStatus();
    
    // Cleanup: Component unmount olduğunda interval'leri temizle
    return () => {
      if (qrCheckInterval) {
        clearInterval(qrCheckInterval);
      }
      if (autoCheckInterval) {
        clearInterval(autoCheckInterval);
      }
    };
  }, [slug, qrCheckInterval, autoCheckInterval]);

  const createQRCode = async () => {
    try {
      setQrCreating(true);
      setError(null);
      
      console.log('🔄 QR kod oluşturuluyor...');
      
      // Önce WhatsApp client'ı başlat
      const initResponse = await fetch(`https://panel.fbajans.com/api/whatsapp-service/init/${slug}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          proxy_host: "31.59.131.91",
          proxy_port: 8110,
          proxy_user: "nzR2PgBN",
          proxy_pass: "nzR2PgBN"
        })
      });
      
      const initData = await initResponse.json();
      
      if (initData.success) {
        // Direkt QR resmi URL'ini kullan
        const qrUrl = `https://panel.fbajans.com/api/whatsapp-service/qr-image/${slug}?t=${Date.now()}`;
        
        setQrCode(qrUrl);
        setQrTimestamp(Date.now());
        setShowQR(true);
        setQrValidityCountdown(30);
        setError(null);
      } else {
        setError('WhatsApp client başlatılamadı');
      }
    } catch (err) {
      setError('QR kod oluşturulamadı: ' + err.message);
    } finally {
      setQrCreating(false);
    }
  };

  useEffect(() => {
    fetchStatus();
  }, [slug]);

  // Countdown timer
  useEffect(() => {
    let interval;
    if (countdown && countdown > 0) {
      interval = setInterval(() => {
        setCountdown(prev => {
          if (prev <= 1) {
            // Countdown bitti, durumu yenile
            fetchStatus();
            return null;
          }
          return prev - 1;
        });
      }, 1000);
    }
    
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [countdown]);

  // QR geçerlilik sayacı
  useEffect(() => {
    let interval;
    if (qrValidityCountdown && qrValidityCountdown > 0) {
      interval = setInterval(() => {
        setQrValidityCountdown(prev => {
          if (prev <= 1) {
            // QR süresi doldu, gizle
            setShowQR(false);
            setQrCode(null);
            return null;
          }
          return prev - 1;
        });
      }, 1000);
    }
    
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [qrValidityCountdown]);

  if (loading) {
    return (
      <div className="whatsapp-status-panel">
        <div className="status-loading">
          <div className="spinner"></div>
          <p>Durum yükleniyor...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="whatsapp-status-panel">
        <div className="status-error">
          <p><i className="fas fa-exclamation-circle" style={{ marginRight: '8px' }}></i>{error}</p>
          <button onClick={fetchStatus} className="btn btn-primary">
            Tekrar Dene
          </button>
        </div>
      </div>
    );
  }

  if (!status) {
    return null;
  }

  const hasRemainingDays = typeof stats?.remaining_days === 'number';
  const licenseExpired = hasRemainingDays && stats.remaining_days <= 0;
  const messageLimit = Number(stats?.message_limit || 0);
  const messagesSent = Number(stats?.messages_sent || 0);
  const quotaExceeded = messageLimit > 0 && messagesSent >= messageLimit;
  const isBlockedByLicenseOrQuota =
    status?.panel_action === 'not_started' && (licenseExpired || quotaExceeded);

  const blockReasons = [];
  if (licenseExpired) {
    blockReasons.push('Lisans süreniz dolmuş durumda.');
  }
  if (quotaExceeded) {
    blockReasons.push('Mesaj kotanız dolmuş durumda.');
  }

  const getStatusIcon = (action) => {
    switch (action) {
      case 'connected':
        return <i className="fas fa-check-circle" style={{ color: '#28a745' }}></i>;
      case 'qr_waiting':
        return <i className="fas fa-mobile-alt" style={{ color: '#ffc107' }}></i>;
      case 'checking':
        return <i className="fas fa-clock" style={{ color: '#17a2b8' }}></i>;
      case 'start_session':
        return <i className="fas fa-rocket" style={{ color: '#007bff' }}></i>;
      default:
        return <i className="fas fa-question-circle" style={{ color: '#6c757d' }}></i>;
    }
  };

  const getStatusColor = (action) => {
    switch (action) {
      case 'connected':
        return 'success';
      case 'qr_waiting':
        return 'warning';
      case 'checking':
        return 'info';
      case 'start_session':
        return 'primary';
      default:
        return 'secondary';
    }
  };

  return (
    <div style={{
      background: 'white',
      borderRadius: '16px',
      padding: isCompact ? '16px' : '24px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
      border: '1px solid #f0f0f0',
      marginBottom: '20px'
    }}>
      {/* Header */}
      <div style={{
        display: 'flex',
        justifyContent: isCompact ? 'flex-start' : 'space-between',
        alignItems: isCompact ? 'flex-start' : 'center',
        marginBottom: '20px',
        flexDirection: isCompact ? 'column' : 'row',
        gap: isCompact ? '12px' : '0'
      }}>
        <h3 style={{ 
          margin: 0, 
          fontSize: '18px', 
          fontWeight: '600', 
          color: '#333',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          width: isCompact ? '100%' : 'auto'
        }}>
          <i className="fas fa-mobile-alt" style={{ marginRight: '8px' }}></i>
          WhatsApp Durumu
        </h3>
        <div style={{
          display: 'flex',
          gap: '8px',
          flexWrap: 'wrap',
          justifyContent: isCompact ? 'flex-start' : 'flex-end',
          width: isCompact ? '100%' : 'auto'
        }}>
          <button 
            onClick={refreshStatus} 
            style={{
              background: '#007bff',
              color: 'white',
              border: 'none',
              padding: '8px 16px',
              borderRadius: '8px',
              fontSize: '14px',
              fontWeight: '500',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '6px'
            }}
            disabled={loading}
          >
            <i className="fas fa-sync-alt" style={{ marginRight: '8px' }}></i>
            Yenile
          </button>
          
          {status?.panel_action === 'connected' && (
            <button 
              onClick={disconnectWhatsApp}
              style={{
                background: '#dc3545',
                color: 'white',
                border: 'none',
                padding: '8px 16px',
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: '500',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '6px'
              }}
              disabled={loading}
            >
              <i className="fas fa-times" style={{ marginRight: '8px' }}></i>
              Bağlantıyı Kes
            </button>
          )}
        </div>
      </div>

      {/* Ana İçerik - Flex Layout */}
      <div style={{
        display: 'flex',
        gap: '16px',
        alignItems: 'stretch',
        flexDirection: 'column'
      }}>
        {/* Sol Taraf - WhatsApp Durumu */}
        <div style={{ flex: 1 }}>
          {/* Ana İçerik - Tek Çerçeve */}
          <div style={{
            padding: isCompact ? '16px' : '20px',
            background: '#f8f9fa',
            borderRadius: '12px',
            border: '1px solid #e9ecef'
          }}>
        {/* Status Durumu - Ortada */}
        <div style={{
          textAlign: 'center',
          marginBottom: '20px'
        }}>
          {status.panel_action === 'connected' ? (
            <div style={{
              background: '#d4edda',
              color: '#155724',
              padding: isCompact ? '16px' : '20px',
              borderRadius: '12px',
              border: '1px solid #c3e6cb'
            }}>
              <i className="fas fa-check-circle" style={{ fontSize: isCompact ? '36px' : '48px', marginBottom: '12px', color: '#28a745' }}></i>
              <h4 style={{ margin: '0 0 8px 0', fontSize: isCompact ? '18px' : '20px', fontWeight: '600' }}>
                Entegrasyonunuz Tamamlandı!
              </h4>
              <p style={{ margin: '0 0 12px 0', fontSize: isCompact ? '14px' : '16px' }}>
                Şu anda bağlandınız. Sayfanızı dilerseniz yenileyebilirsiniz.
              </p>
              <div style={{ fontSize: isCompact ? '12px' : '14px', color: '#0f5132' }}>
                Son kontrol: {new Date(status.last_check).toLocaleString('tr-TR')}
              </div>
            </div>
          ) : status.panel_action === 'show_qr' && showQR && qrCode ? (
            <div style={{
              background: '#d1ecf1',
              color: '#0c5460',
              padding: isCompact ? '16px' : '20px',
              borderRadius: '12px',
              border: '1px solid #bee5eb'
            }}>
              <h4 style={{ margin: '0 0 16px 0', fontSize: isCompact ? '18px' : '20px', fontWeight: '600' }}>
                <i className="fas fa-mobile-alt" style={{ marginRight: '8px' }}></i>
                QR Kodunuzu Tarayın
              </h4>
              <div style={{ marginBottom: '16px' }}>
                <img 
                  src={qrCode}
                  alt="WhatsApp QR Code"
                  style={{ 
                    maxWidth: isCompact ? '200px' : '250px', 
                    height: 'auto',
                    border: '3px solid #bee5eb',
                    borderRadius: '12px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                  }}
                  onError={(e) => {
                    console.error('QR kod resim yükleme hatası:', e);
                    setError('QR kod resmi yüklenemedi');
                    setShowQR(false);
                  }}
                  onLoad={() => {
                    console.log('QR kod resmi başarıyla yüklendi');
                  }}
                />
              </div>
              <p style={{ margin: '0 0 16px 0', fontSize: '16px' }}>
                Telefonunuzla bu QR kodu tarayın
              </p>
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                gap: '12px',
                marginBottom: '12px'
              }}>
                <button 
                  onClick={createQRCode}
                  style={{
                    background: '#ffc107',
                    color: '#212529',
                    border: 'none',
                    padding: '10px 20px',
                    borderRadius: '8px',
                    fontSize: '14px',
                    fontWeight: '500',
                    cursor: 'pointer'
                  }}
                  disabled={qrCreating}
                >
                  <i className="fas fa-sync-alt" style={{ marginRight: '8px' }}></i>
                  Yeni QR
                </button>
                <button 
                  onClick={() => setShowQR(false)}
                  style={{
                    background: '#6c757d',
                    color: 'white',
                    border: 'none',
                    padding: '10px 20px',
                    borderRadius: '8px',
                    fontSize: '14px',
                    fontWeight: '500',
                    cursor: 'pointer'
                  }}
                >
                  <i className="fas fa-times" style={{ marginRight: '8px' }}></i>
                  Kapat
                </button>
              </div>
              <div style={{ fontSize: '14px', color: '#0c5460' }}>
                <i className="fas fa-clock" style={{ marginRight: '8px' }}></i>
                Geçerlilik: {qrValidityCountdown}s
              </div>
            </div>
          ) : status.panel_action === 'not_started' ? (
            <div style={{
              background: isBlockedByLicenseOrQuota ? '#f8d7da' : '#fff3cd',
              color: isBlockedByLicenseOrQuota ? '#842029' : '#856404',
              padding: '20px',
              borderRadius: '12px',
              border: isBlockedByLicenseOrQuota ? '1px solid #f5c2c7' : '1px solid #ffeaa7'
            }}>
              <i
                className={isBlockedByLicenseOrQuota ? 'fas fa-shield-alt' : 'fas fa-power-off'}
                style={{
                  fontSize: '48px',
                  marginBottom: '12px',
                  color: isBlockedByLicenseOrQuota ? '#dc3545' : '#ffc107'
                }}
              ></i>
              <h4 style={{ margin: '0 0 8px 0', fontSize: '20px', fontWeight: '600' }}>
                {isBlockedByLicenseOrQuota ? 'Erişim Koşulları Sağlanmıyor' : 'Oturum Başlatılmadı'}
              </h4>
              <p style={{ margin: '0 0 16px 0', fontSize: '16px' }}>
                {isBlockedByLicenseOrQuota
                  ? "Oturumunuzu başlatmak için Lisans / Kota'nızı yenileyin"
                  : 'WhatsApp entegrasyonu için önce oturumu başlatmanız gerekiyor'}
              </p>
              {isBlockedByLicenseOrQuota ? (
                <div
                  style={{
                    background: '#fff',
                    border: '1px solid #f1aeb5',
                    borderRadius: '10px',
                    padding: '12px 14px',
                    maxWidth: '560px',
                    margin: '0 auto',
                    textAlign: 'left'
                  }}
                >
                  <div style={{ fontSize: '13px', fontWeight: 700, marginBottom: '8px', color: '#842029' }}>
                    Yenileme Gereken Alanlar
                  </div>
                  <ul style={{ margin: 0, paddingLeft: '18px', fontSize: '14px', color: '#842029' }}>
                    {blockReasons.map((reason, index) => (
                      <li key={index} style={{ marginBottom: '4px' }}>{reason}</li>
                    ))}
                  </ul>
                </div>
              ) : (
                <button
                  onClick={startSession}
                style={{
                  background: '#28a745',
                  color: 'white',
                  border: 'none',
                  padding: '12px 24px',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontWeight: '500',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  margin: '0 auto'
                }}
                  disabled={loading}
                >
                  <i className="fas fa-play" style={{ marginRight: '8px' }}></i>
                  Oturumu Başlat
                </button>
              )}
            </div>
          ) : status.panel_action === 'initializing' ? (
            <div style={{
              background: '#e8f4fd',
              color: '#0c5460',
              padding: '28px 20px',
              borderRadius: '12px',
              border: '1px solid #bee5eb',
              textAlign: 'center'
            }}>
              <div style={{ fontSize: '48px', marginBottom: '12px' }}>⏳</div>
              <h4 style={{ margin: '0 0 8px 0', fontSize: '20px', fontWeight: '600' }}>
                WhatsApp Başlatılıyor...
              </h4>
              <p style={{ margin: '0 0 8px 0', fontSize: '15px' }}>
                Tarayıcı açılıyor, lütfen bekleyin. Bu işlem 10-20 saniye sürebilir.
              </p>
              <div style={{ fontSize: '13px', color: '#0c5460', marginTop: '8px', opacity: 0.8 }}>
                Hazır olduğunda bağlantı seçenekleri otomatik görünecek.
              </div>
            </div>
          ) : (
            <div style={{
              background: '#fff3cd',
              color: '#856404',
              padding: '20px',
              borderRadius: '12px',
              border: '1px solid #ffeaa7'
            }}>
              <i className="fas fa-mobile-alt" style={{ fontSize: '48px', marginBottom: '12px', color: '#ffc107' }}></i>
              <h4 style={{ margin: '0 0 8px 0', fontSize: '20px', fontWeight: '600' }}>
                QR Kodunuzu Oluşturun
              </h4>
              <p style={{ margin: '0 0 16px 0', fontSize: '16px' }}>
                WhatsApp entegrasyonu için QR kod oluşturmanız gerekiyor
              </p>
              <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
                <button
                  onClick={() => window.open(`/qr/${slug}?tab=qr`, '_blank')}
                  style={{
                    background: '#007bff',
                    color: 'white',
                    border: 'none',
                    padding: '12px 20px',
                    borderRadius: '8px',
                    fontSize: '15px',
                    fontWeight: '500',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}
                  disabled={status.panel_button_disabled || loading}
                >
                  <i className="fas fa-qrcode"></i>
                  QR Kodu ile Bağlan
                </button>
                <button
                  onClick={() => window.open(`/qr/${slug}?tab=phone`, '_blank')}
                  style={{
                    background: '#128C7E',
                    color: 'white',
                    border: 'none',
                    padding: '12px 20px',
                    borderRadius: '8px',
                    fontSize: '15px',
                    fontWeight: '500',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}
                  disabled={status.panel_button_disabled || loading}
                >
                  <i className="fas fa-mobile-alt"></i>
                  Telefon Numarası ile Bağlan
                </button>
              </div>
            </div>
          )}
        </div>

        {/* QR Oluşturuluyor Durumu - Sadece QR yokken göster */}
        {qrCreating && !showQR && !qrCode && (
          <div style={{
            padding: '16px',
            background: '#fff3cd',
            border: '1px solid #ffeaa7',
            borderRadius: '8px',
            textAlign: 'center',
            marginBottom: '16px'
          }}>
            <i className="fas fa-spinner fa-spin" style={{ fontSize: '24px', marginBottom: '8px', color: '#856404' }}></i>
            <h4 style={{ margin: '0 0 8px 0', fontSize: '16px', color: '#856404' }}>
              QR Kod Oluşturuluyor
            </h4>
            <p style={{ margin: 0, fontSize: '14px', color: '#856404' }}>
              Lütfen bekleyin... QR kod hazırlanıyor
            </p>
          </div>
        )}

            {/* Footer Bilgileri */}
            <div style={{
              marginTop: '16px',
              padding: '12px',
              background: 'white',
              borderRadius: '8px',
              fontSize: '12px',
              color: '#6c757d',
              textAlign: 'center'
            }}>
              Proxy: {status.proxy_status || 'Bilinmiyor'} | 
              Son oturum: {status.last_session_start ? 
                new Date(status.last_session_start).toLocaleString('tr-TR') : 
                'Hiç başlatılmadı'
              }
            </div>
          </div>
        </div>

        {/* Sağ Taraf - Küçük İstatistik Kutuları */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: isCompact ? 'repeat(2, minmax(0, 1fr))' : 'repeat(4, minmax(0, 1fr))',
          gap: '12px',
          width: '100%'
        }}>
          {/* Mesaj Kullanımı */}
          <div style={{
            background: 'linear-gradient(135deg, #28a745, #20c997)',
            color: 'white',
            padding: window.innerWidth <= 768 ? '12px' : '16px',
            borderRadius: '12px',
            border: '2px solid #e9ecef',
            position: 'relative',
            overflow: 'hidden'
          }}>
            <div style={{
              position: 'absolute',
              top: '8px',
              right: '8px',
              fontSize: '20px',
              color: 'white',
              opacity: 0.8
            }}>
              <i className="fas fa-chart-bar" style={{ fontSize: '24px' }}></i>
            </div>
            <div style={{
              fontSize: '24px',
              fontWeight: '700',
              marginBottom: '4px'
            }}>
              {stats?.messages_sent || 0} / {stats?.message_limit || 0}
            </div>
            <div style={{
              fontSize: '12px',
              opacity: 0.9,
              fontWeight: '500'
            }}>
              Mesaj Kullanımı
            </div>
            <div style={{
              position: 'absolute',
              bottom: '0',
              left: '0',
              right: '0',
              height: '3px',
              background: 'rgba(255,255,255,0.3)'
            }}>
              <div style={{
                height: '100%',
                background: 'white',
                width: `${((stats?.messages_sent || 0) / (stats?.message_limit || 1)) * 100}%`,
                transition: 'width 0.3s ease'
              }}></div>
            </div>
          </div>

          {/* Kalan Gün */}
          <div style={{
            background: 'linear-gradient(135deg, #ffc107, #fd7e14)',
            color: 'white',
            padding: window.innerWidth <= 768 ? '12px' : '16px',
            borderRadius: '12px',
            border: '2px solid #e9ecef',
            position: 'relative',
            overflow: 'hidden'
          }}>
            <div style={{
              position: 'absolute',
              top: '8px',
              right: '8px',
              fontSize: '20px',
              color: 'white',
              opacity: 0.8
            }}>
              <i className="fas fa-calendar-alt" style={{ fontSize: '20px' }}></i>
            </div>
            <div style={{
              fontSize: '24px',
              fontWeight: '700',
              marginBottom: '4px'
            }}>
              {stats?.remaining_days || 0}
            </div>
            <div style={{
              fontSize: '12px',
              opacity: 0.9,
              fontWeight: '500'
            }}>
              Kalan Gün
            </div>
          </div>

          {/* Lisans Başlangıç */}
          <div style={{
            background: 'linear-gradient(135deg, #007bff, #6f42c1)',
            color: 'white',
            padding: window.innerWidth <= 768 ? '12px' : '16px',
            borderRadius: '12px',
            border: '2px solid #e9ecef',
            position: 'relative',
            overflow: 'hidden'
          }}>
            <div style={{
              position: 'absolute',
              top: '8px',
              right: '8px',
              fontSize: '20px',
              color: 'white',
              opacity: 0.8
            }}>
              <i className="fas fa-rocket" style={{ fontSize: '20px' }}></i>
            </div>
            <div style={{
              fontSize: '24px',
              fontWeight: '700',
              marginBottom: '4px'
            }}>
              {stats?.license_start_date ? new Date(stats.license_start_date).toLocaleDateString('tr-TR') : 'N/A'}
            </div>
            <div style={{
              fontSize: '12px',
              opacity: 0.9,
              fontWeight: '500'
            }}>
              Lisans Başlangıç
            </div>
          </div>

          {/* Lisans Bitiş */}
          <div style={{
            background: 'linear-gradient(135deg, #dc3545, #e83e8c)',
            color: 'white',
            padding: window.innerWidth <= 768 ? '12px' : '16px',
            borderRadius: '12px',
            border: '2px solid #e9ecef',
            position: 'relative',
            overflow: 'hidden',
            flex: window.innerWidth <= 768 ? '1 1 45%' : 'none',
            minWidth: window.innerWidth <= 768 ? '140px' : 'auto'
          }}>
            <div style={{
              position: 'absolute',
              top: '8px',
              right: '8px',
              fontSize: '20px',
              color: 'white',
              opacity: 0.8
            }}>
              <i className="fas fa-clock" style={{ fontSize: '20px' }}></i>
            </div>
            <div style={{
              fontSize: '24px',
              fontWeight: '700',
              marginBottom: '4px'
            }}>
              {stats?.license_end_date ? new Date(stats.license_end_date).toLocaleDateString('tr-TR') : 'N/A'}
            </div>
            <div style={{
              fontSize: '12px',
              opacity: 0.9,
              fontWeight: '500'
            }}>
              Lisans Bitiş
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhatsAppStatusPanel;
